import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";

const propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export const WatchViewContext = createContext([]);

export const useWatchViewContext = () => useContext(WatchViewContext);

export const WatchViewProvider = ({ children }) => {
  const [viewIndex, setViewIndex] = useState(0);
  const [animationState, setAnimationState] = useState("ENTERING");

  const fadeInOut = (index) => {
    if (index !== viewIndex) {
      setAnimationState("LEAVING");
      setTimeout(() => {
        setViewIndex(index);
        setAnimationState("ENTERING");
      }, 200);
    }
  };

  const goToNextView = () => fadeInOut(viewIndex + 1);

  const goToPreviousView = () => fadeInOut(viewIndex - 1);

  const goToSpecificView = (index) => fadeInOut(index);

  return (
    <WatchViewContext.Provider
      value={{
        viewIndex,
        goToNextView,
        goToPreviousView,
        goToSpecificView,
        animationState,
        setAnimationState,
      }}
    >
      {children}
    </WatchViewContext.Provider>
  );
};

WatchViewProvider.propTypes = propTypes;

export default WatchViewProvider;
